import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { useHistory, useParams } from 'react-router-dom';

import BaseTimelineCard from '@ts-core/components/Timeline/BaseTimelineCard';

import styles from './timelineAssignmentCardStyles';

import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

import WorkIcon from '@mui/icons-material/Work';

import ConfirmationDialog from '@ts-core/components/ConfirmationDialog';

const useStyles = makeStyles(styles);

const TimelineAssignmentCard = (props) => {
  const classes = useStyles();

  const history = useHistory();
  const { courseId } = useParams();

  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);

  const { assignment, professor, academy } = props;
  const { timeLimit } = assignment;
  const { startedAt } = assignment?.answer || {};

  const date = moment(assignment.expirationDate);

  const handleStartAssignment = useCallback(() => {
    history.push(`/${courseId}/assignments/${assignment.id}/do`);
  }, [history, assignment, courseId]);

  const handleCancelStartAssignment = useCallback(() => {
    setIsConfirmDialogOpen(false);
  }, []);

  const handleSelectAssignment = () => {
    if (timeLimit && !startedAt) {
      setIsConfirmDialogOpen(true);
    } else {
      handleStartAssignment();
    }
  };

  return (
    <BaseTimelineCard title={professor.name} subtitle={academy.name}>
      <div className={classes.titleContainer}>
        <WorkIcon />
        <Typography variant="h6" display="inline" className={classes.assignmentTitle}>
          {assignment.name}
        </Typography>
      </div>
      <Typography variant="body2" color="textSecondary" display="inline">
        <FormattedMessage id="studentAssignments.dueDate" />{' '}
      </Typography>
      <Typography variant="body2" color="textSecondary" style={{ fontWeight: 'bold' }} display="inline">
        {date.format(date.isSame(new Date(), 'year') ? 'DD MMMM HH:mm' : 'DD MMMM YYYY HH:mm')}
      </Typography>
      <Grid container justifyContent="flex-end">
        <Grid item>
          <Button onClick={handleSelectAssignment} color="secondary">
            <FormattedMessage id="studentAssignments.do" />
          </Button>
        </Grid>
      </Grid>
      <ConfirmationDialog
        open={isConfirmDialogOpen}
        title={<FormattedMessage id="studentAssignment.withTimeLimitAlert.title" />}
        message={
          <FormattedMessage
            id="studentAssignment.withTimeLimitAlert.message"
            values={{
              minutes: assignment ? assignment.timeLimit : 0,
            }}
          />
        }
        confirmActionTitle={<FormattedMessage id="button.start" />}
        cancelActionTitle={<FormattedMessage id="button.cancel" />}
        onCancel={handleCancelStartAssignment}
        onConfirm={handleStartAssignment}
      />
    </BaseTimelineCard>
  );
};

TimelineAssignmentCard.propTypes = {
  professor: PropTypes.object.isRequired,
  academy: PropTypes.object.isRequired,
  assignment: PropTypes.object.isRequired,
};

export default TimelineAssignmentCard;
